import styled from 'styled-components';

import { SubHeadline } from 'ggApp/shared/common/Typography';
import { LinkContainer } from './ShareButton/styles'

const Container = styled.section`
    display: flex;
    flex-direction: column;
`;

const Title = styled(SubHeadline)`
    height: 32px;
    margin-bottom: 8px;
`;

const List = styled.ul`
    display: flex;
    flex-direction: column;
    border-radius: 8px;
`;

const Item = styled.li`
    display: flex;
    align-items: center;
    cursor: pointer;
    &:not(:first-child) {
        border-top: 2px solid ${(props) => props.theme.colors['Level 1']};
    }

    @media (hover: hover) {
        &:hover {
            background: ${(props) => props.theme.colors['Level 1']};
        }
    }
`;

const DefaultItem = styled(Item)`
    @media (hover: hover) {
        &:hover {
            background: unset;
        }
    }
`;

const CopyItem = styled(LinkContainer)``

export {
    Container,
    Title,
    List,
    Item,
    DefaultItem,
    CopyItem
};
